module.exports = "<div>\n<div id=\"container\" style=\"height:300px;width:50%\"></div>\n<button width=\"50\">fffd</button>\n<input></input>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 275
// module chunks = 0